/* BiteClutch storefront motion + lightweight UX helpers */
(function () {
  if (window.__biteClutchMotion) return;
  window.__biteClutchMotion = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  root.classList.add('bite-motion-ready');

  function initReveals(scope) {
    scope = scope || document;
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-bite-reveal]:not([data-bite-motion-bound])'));
    if (!nodes.length) return;
    nodes.forEach(function (el) { el.setAttribute('data-bite-motion-bound', 'true'); });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('bite-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bite-in-view');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    nodes.forEach(function (el) { observer.observe(el); });
  }

  function initHeroParallax() {
    var hero = document.querySelector('.bite-hero-v2');
    if (!hero || reduceMotion) return;
    var stage = hero.querySelector('.bite-hero-stage');
    if (!stage) return;
    var ticking = false;
    function update() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var progress = Math.max(-1, Math.min(1, rect.top / Math.max(window.innerHeight, 1)));
      stage.style.setProperty('--bite-parallax', (progress * -10).toFixed(2) + 'px');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function initSearchShortcuts(scope) {
    (scope || document).querySelectorAll('[data-bite-search-term]').forEach(function (link) {
      if (link.dataset.biteSearchBound) return;
      link.dataset.biteSearchBound = 'true';
      link.addEventListener('click', function () {
        var term = link.getAttribute('data-bite-search-term');
        var input = document.querySelector('.bite-hero-search input[type="search"]');
        if (input && term) input.value = term;
      });
    });
  }


  function initBuyNow(scope) {
    (scope || document).querySelectorAll('[data-bite-buy-now]').forEach(function (button) {
      if (button.dataset.biteBuyBound) return;
      button.dataset.biteBuyBound = 'true';
      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        var checkoutUrl = button.getAttribute('data-checkout-url') || '/checkout';
        if (!variantId || button.disabled) return;
        var original = button.innerHTML;
        button.disabled = true;
        button.textContent = 'Opening…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: 'id=' + encodeURIComponent(variantId) + '&quantity=1'
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to add item');
          window.location.assign(checkoutUrl);
        }).catch(function () {
          button.disabled = false;
          button.innerHTML = original;
          window.location.assign(button.closest('.bite-product-card-v2')?.querySelector('h3 a')?.href || '/cart');
        });
      });
    });
  }

  function init() {
    initReveals(document);
    initHeroParallax();
    initSearchShortcuts(document);
    initBuyNow(document);
    requestAnimationFrame(function () { root.classList.add('bite-page-loaded'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
    initSearchShortcuts(event.target);
    initBuyNow(event.target);
  });
})();
